import { Form, Skeleton, Button, Row, Col, Radio, Card, ConfigProvider, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { connect } from 'react-redux';
import StoreRepo from '../../repository/StoreRepository';
import handleRsponse from '../../helper/handleRsponse';

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'rowNumber',
        width: 65,

    },
    {
        title: 'شناسه رهگیری',
        dataIndex: 'interceptNo',
        width: 190,
    },
    {
        title: 'شماره سریال',
        dataIndex: 'serialNo',
        width: 190,
    },
    {
        title: 'مدل',
        dataIndex: 'modelName',

    },
];
const data = [];
for (let i = 0; i < 100; i++) {
    data.push({
        key: i,
        name: `Edward King ${i}`,
        age: 32,
        address: `London, Park Lane no. ${i}`,
    });
}
const { Meta } = Card;
const StoreFactor = (props) => {
    const [isLoaded, setIsLoaded] = useState(true);
    const [factor, setFactor] = useState({ name: '', sendDate: '', code: '', callNumber: '', address: '', truckerNumber: '', factorItems: [{}, {}, {}] });
    useEffect(() => {
        let factorNo = (queryString.parse(props.location.search).fk);
        if (factorNo !== undefined)
            handleRsponse.handleAxios(StoreRepo.getStoreInfo(`factorNo=${factorNo}`), fillFactor, setIsLoaded);
    }, []);
    const fillFactor = (response) => {
        console.log(handleRsponse.getResponse(response), 'testttt');
        setFactor(handleRsponse.getResponse(response));
    }
    const itemCards = (factor.factorItems != null) ? factor.factorItems.map((item, i) => {
        return (
            <Col xs={20} xl={8} lg={8} md={8}>
                <div key={item.id} >
                    <Card hoverable >
                        <Skeleton
                            show={!isLoaded}
                            loading={!isLoaded}
                            active
                            paragraph={{
                                rows: 4,
                            }}
                            size='small'
                        >
                            {/* <Meta title={'شناسه رهگیری:'+item.interceptNo} description={item.modelName} /> */}
                            <p><b>ردیف:</b>{+item.rowNumber}</p>
                            <p><b>شناسه رهگیری:</b>{item.interceptNo}</p>
                            <p><b>شماره سریال:</b>{item.serialNo}</p>
                            {/* <p><b>کد مدل:</b>{item.modelCode}</p> */}
                            <p><b>مدل:</b>{item.modelName}</p>
                        </Skeleton>
                    </Card>
                </div>
            </Col>
        )
    }) : '';
    return (
        <ConfigProvider direction="rtl">

            <div style={{ padding: 20 }}>
                <Row >
                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                        <b>نام فروشگاه:</b><span>{factor.name}</span>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                        <b>کد فروشگاه:</b><span>{factor.code}</span>
                    </Col>
                </Row>
                <Row>
                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                        <b>شماه تماس:</b><span>{factor.callNumber}</span>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                        <b>تاریخ ارسال:</b><span>{factor.sendDate}</span>
                    </Col>
                </Row>
                <Row>
                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                        <b>حواله:</b><span>{factor.truckerNumber}</span>
                    </Col>

                </Row>
                {/* <Row>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <b>آدرس:</b><span>{factor.address}</span>
                </Col>
            </Row> */}
            </div>

            {/* <Row gutter={16} className="noMargin">
                {itemCards}
            </Row> */}
            <Row>
                <Skeleton
                    show={!isLoaded}
                    loading={!isLoaded}
                    active
                    paragraph={{
                        rows: 4,
                    }}
                   
                >
                    <Table
                        columns={columns}
                        dataSource={factor.factorItems}
                        bordered
                        pagination={{
                            pageSize: 50,
                            position: ['none', 'none'],
                        }}
                        scroll={{
                            x: 1000,
                            y: 400,
                        }}
                    />
                </Skeleton>

            </Row>

        </ConfigProvider>
    )
}
const mapStateToProps = state => ({});
const mapActionCreateor = {

}
export default connect(mapStateToProps, mapActionCreateor)(StoreFactor)